<template>
  <v-card tile>
    <v-progress-linear height="4" :value="progress" class="my-0"></v-progress-linear>
    <v-list>
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title>{{ currentEventName }}</v-list-tile-title>
          <v-list-tile-sub-title>{{ currentEventDate }}</v-list-tile-sub-title>
        </v-list-tile-content>
        <v-spacer></v-spacer>
        <v-list-tile-action>
          <v-btn
            icon
            @click.stop="$emit('open-config-dialog')"
          >
            <v-icon>settings</v-icon>
          </v-btn>
        </v-list-tile-action>
        <v-list-tile-action
          :class="{
            'mx-5': $vuetify.breakpoint.mdAndUp
          }"
        >
          <v-btn
            icon
            @click="$emit('update:travelIndex', 1)"
          >
            <v-icon>replay</v-icon>
          </v-btn>
        </v-list-tile-action>
        <v-list-tile-action
          :class="{
            'mr-5': $vuetify.breakpoint.mdAndUp
          }"
        >
          <v-btn
            icon
            :disabled="disablePreviousStep"
            @click="$emit('update:travelIndex', travelIndex - 1)"
          >
            <v-icon>fast_rewind</v-icon>
          </v-btn>
        </v-list-tile-action>
        <v-list-tile-action
          :class="{
            'mr-5': $vuetify.breakpoint.mdAndUp
          }"
        >
          <v-btn
            icon
            :disabled="disablePlay"
            @click="playing = !playing"
          >
            <v-icon v-if="playing">pause</v-icon>
            <v-icon v-else>play_arrow</v-icon>
          </v-btn>
        </v-list-tile-action>
        <v-list-tile-action
          :class="{
            'mr-5': $vuetify.breakpoint.mdAndUp
          }"
        >
          <v-btn
            icon
            :disabled="disableNextStep"
            @click="$emit('update:travelIndex', travelIndex + 1)"
          >
            <v-icon>fast_forward</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
  </v-card>
</template>

<script>
import { find } from 'lodash'

export default {
  name: 'controls',
  props: {
    events: Array,
    travelSteps: Array,
    travelIndex: Number
  },
  data: function () {
    return {
      playing: false,
      disablePlay: false,
      disableNextStep: false,
      disablePreviousStep: true,
      interval: {},
      nextTravelStepTick: 2000,
      currentEventName: '',
      currentEventDate: ''
    }
  },
  computed: {
    progress: function () {
      if (this.travelSteps.length === 0) {
        return 0
      }
      const progress = parseInt((100 * this.travelIndex) / this.travelSteps.length)
      return progress > 100 ? 100 : progress
    }
  },
  watch: {
    travelIndex: function (travelIndex) {
      this.followTravelIndex(travelIndex)
    },
    playing: function (playing) {
      if (playing) {
        this.interval = setInterval(() => {
          this.$emit('update:travelIndex', this.travelIndex + 1)
        }, this.nextTravelStepTick)
      } else {
        clearInterval(this.interval)
      }
    }
  },
  methods: {
    followTravelIndex: function (travelIndex) {
      // Handle empty travel
      if (this.travelSteps.length === 0) {
        console.log('No hay eventos para mostrar')
        this.playing = false
        return false
      }
      // Handle previous step
      if (travelIndex <= 1) {
        this.disablePreviousStep = true
      } else {
        this.disablePreviousStep = false
      }
      // Handle play and next step
      if (travelIndex === this.travelSteps.length) {
        this.disablePlay = true
        this.disableNextStep = true
        this.playing = false
      } else {
        this.disablePlay = false
        this.disableNextStep = false
      }
      const step = this.travelSteps[travelIndex - 1]
      const event = find(this.events, { _id: step.eventId })
      const eventDate = new Date(event.data.gps.date).toLocaleString()
      this.currentEventName = event.name
      this.currentEventDate = eventDate
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Travels/Controls.vue